/**
 * The dental pilot's tooth mark.
 *
 * The path is the one drawn for the onboarding welcome card's journey seal
 * (components/flows/DentalJourneySeal.tsx), lifted here so both surfaces draw
 * the same tooth rather than two that drift apart.
 */

// Verbatim from the design file. Do NOT wrap this across lines: path data has
// no statement separator, so joining two fragments fuses the numbers at the
// seam (-2.1 + 1.6 becomes -2.11.6) and silently warps the shape — nothing in
// the type system or the build catches it.
export const TOOTH_PATH =
  "M12 2.6c-2.3 0-3.1.9-4.9.9C4.8 3.5 3.4 5.4 3.4 7.7c0 1.9.8 3 1.3 4.7.5 1.8.7 4.1 1.1 6.2.3 1.3.7 2.8 1.8 2.8 1.8 0 1-4.3 2.4-6.2.5-.7 1.6-.7 2.1 0 1.4 1.9.6 6.2 2.4 6.2 1.1 0 1.5-1.5 1.8-2.8.4-2.1.6-4.4 1.1-6.2.5-1.7 1.3-2.8 1.3-4.7 0-2.3-1.4-4.2-3.7-4.2-1.8 0-2.6-.9-5-.9z";

/**
 * Inherits the current text colour, so callers set it with a text-* class.
 *
 * `outline` draws the same path as a stroke instead of a fill — a lighter
 * mark for headings, where a solid teal tooth reads heavier than the text
 * beside it. The stroke width is in viewBox units, so it scales with the
 * icon rather than staying a fixed pixel width.
 */
export function ToothIcon({
  className,
  outline = false,
}: {
  className?: string;
  outline?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={outline ? "none" : "currentColor"}
      stroke={outline ? "currentColor" : "none"}
      strokeWidth={outline ? 1.75 : undefined}
      strokeLinejoin="round"
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
    >
      <path d={TOOTH_PATH} />
    </svg>
  );
}
